<template>
  <nav class="the-menu">
    <img src="@/assets/peristock-logo.png" alt="" class="peristockLogo" />
    <a href="#">Termes du service</a>
    <a href="mailto:peristock.dev@gmail.com" class="opacity-70">Contact</a>
  </nav>
</template>


<style lang="postcss" scoped>
.the-menu {
  @apply hidden md:flex min-w-min flex-col justify-center max-h-screen px-10 bg-green-900 -space-y-0.5;
}

a {
  @apply py-3 whitespace-nowrap text-center text-white font-semibold;
}

a:hover {
  @apply opacity-100;
}

.peristockLogo {
  @apply h-32 w-32 rounded-full mx-auto my-4;
}
</style>
